<template>
  <div class="check-group">
    <el-checkbox-group v-model="checkList">
      <div v-for="(item, idx) in options">
        <el-checkbox
          :key="idx"
          :label="item.name"
          :value="item.value"
        ></el-checkbox>
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "FormCheckboxGroup",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
  },
  data() {
    return {
      options: [
        // "Sales & Marketing Department",
        // "Top Management",
        // "Warehouse and Operation Department",
        // "Finance & Accounting Department",
        // "Other Department",
        {
          name: "Sales & Marketing Department",
          value: "Sales & Marketing Department",
        },
        {
          name: "Top Management",
          value: "Top Management",
        },
        {
          name: "Warehouse and Operation Department",
          value: "Warehouse and Operation Department",
        },
        {
          name: "Finance & Accounting Department",
          value: "Finance & Accounting Department",
        },
        {
          name: "Other Department",
          value: "Other Department",
        },
      ],
    };
  },
  computed: {
    checkList: {
      get() {
        if (!!this.value) {
          try {
            return JSON.parse(this.value);
          } catch (error) {}
        }
        return [];
      },
      set(val) {
        this.emitCheckList(val);
      },
    },
  },
  methods: {
    emitCheckList(val) {
      try {
        this.$emit("change", JSON.stringify(val));
      } catch (error) {
        console.log("emit fail", error);
      }
    },
  },
};
</script>

<style></style>
